'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { Popover, PopoverAnchor, PopoverContent } from '../../ui/popover';
/**
 * A small Specra panel anchored to an element, opened by the caller. Its
 * children render only while it is open, so a page pays nothing for it until
 * someone clicks.
 */ export function SpecraPopover({ open, onOpenChange, anchor, children, side = 'bottom', align = 'start', className, portalContainer, 'aria-label': ariaLabel, 'data-testid': testId }) {
    const anchorRef = React.useRef(anchor);
    anchorRef.current = anchor;
    return /*#__PURE__*/ _jsxs(Popover, {
        open: open && !!anchor,
        onOpenChange: onOpenChange,
        children: [
            /*#__PURE__*/ _jsx(PopoverAnchor, {
                virtualRef: anchorRef
            }),
            open && anchor ? /*#__PURE__*/ _jsx(PopoverContent, {
                side: side,
                align: align,
                role: "dialog",
                "aria-label": ariaLabel,
                "data-testid": testId,
                portalContainer: portalContainer,
                onOpenAutoFocus: (e)=>e.preventDefault(),
                className: cn('w-80 max-w-[calc(100vw-var(--component-overlay-edge-gap))] rounded-[var(--radius-lg)] border border-[color:var(--border-card)] bg-[color:var(--surface-panel)] p-[var(--space-3)] text-foreground shadow-md', className),
                children: children
            }) : null
        ]
    });
}
